import { action } from 'typesafe-actions';
import { DialogContentLoading, DialogError } from 'components';
import { DialogsTypes, Dialog } from './types';

// Actions
export const setOpen = (payload: Dialog) =>
  action(DialogsTypes.SET_OPEN, {
    ...payload,
    open: true,
  } as Dialog);

export const setClose = (payload?: any) =>
  action(DialogsTypes.SET_CLOSE, payload);

// To allow dialog over dialog
export const setSecondOpen = (payload: Dialog) =>
  action(DialogsTypes.SET_SECOND_OPEN, {
    ...payload,
    wasCalled: true,
    open: true,
  } as Dialog);

export const setSecondClose = (payload?: any) =>
  action(DialogsTypes.SET_SECOND_CLOSE, payload);

// Error dialog
export const setOpenDialogError = (propsDialog?: {
  title: string;
  message: string;
}) =>
  action(DialogsTypes.SET_OPEN, {
    open: true,
    content: DialogError,
    propsDialog,
  });

// Facilities
export const setOpenLoading = (propsDialog?: any) =>
  action(DialogsTypes.SET_OPEN, {
    open: true,
    content: DialogContentLoading,
    disableBackdropClick: true,
    propsDialog,
  });

export const setSecondOpenLoading = (propsDialog?: any) =>
  action(DialogsTypes.SET_SECOND_OPEN, {
    open: true,
    content: DialogContentLoading,
    disableBackdropClick: true,
    propsDialog,
  });

// isLoading
export const isLoading = (payload: object) =>
  action(DialogsTypes.IS_LOADING, payload);
